import { toJS } from "mobx";
import UserStoreV2 from "../stores/profile/UserStoreV2";

export const getUserObject = () => toJS(UserStoreV2.user_object);
export const getUserId = () => toJS(UserStoreV2.user_object.user_id);

export const getIsUserAdmin = () => toJS(UserStoreV2.user_object.user_security.is_admin)
